import { Component, OnInit } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';
import { AppointmentCalendar } from './../../models/calendar/calendar.model';

@Component({
  selector: 'swb-calendar-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html'
})
export class CalendarListComponent extends ListBase<AppointmentCalendar> implements OnInit {

  public url = 'appointment-calendars';
  public urlPrefix = 'appointments';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
